import { HttpClientService } from './../http-confing/http/http-client.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AboutService {

  constructor(private _Http: HttpClientService ) { }

  get AboutUs() {
    return this._Http.get('about-us/get-all')

  }
  get Branches() {
    return this._Http.get('contact-us/get-all')
  }
  getContact(branchId) {
    return this._Http.get('contact-us/get-branch', {branch_id: branchId})
  }


}
